import React from 'react';
import {
  LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend,BarChart, ResponsiveContainer,
  Bar
} from 'recharts';

/**
 * Componente React per visualizzare un grafico a linee.
 *
 * @param {Array<Object>} data - Un array di oggetti, dove ogni oggetto contiene
 * una data e un valore.
 * Es: [{ data: "2023-01-01", valore: 10 }]
 * @param {string} dataKey - La chiave dell'oggetto che rappresenta la data (asse X). Default: "data"
 * @param {string} valueKey - La chiave dell'oggetto che rappresenta il valore (asse Y). Default: "valore"
 * @param {string} title - Titolo del grafico. Default: "Andamento Valori"
 */
const LineChartComponent = ({
  data,
  idKey = "id",
  valueKey = "valore",
  title = "Andamento Valori"
}) => {

  if (!data || data.length === 0) {
    return <div style={{ textAlign: 'center', padding: '20px', color: '#555' }}>Nessun dato disponibile per il grafico.</div>;
  }

  return (
    <div style={{ width: '100%', height: 400, fontFamily: 'Arial, sans-serif' }}>
      <h3 style={{ textAlign: 'center', marginBottom: '20px', color: '#333' }}>{title}</h3>
      <ResponsiveContainer>
        <BarChart
          data={data}
          margin={{
            top: 5, right: 30, left: 20, bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey={idKey} />
          <YAxis />
          
          <Legend />
          <Line 
            type="monotone" 
            dataKey={valueKey} 
            stroke="#8884d8" 
            activeDot={{ r: 1 }} 
            name="Valore" // Nome che appare nella legenda e tooltip
          />
          <Tooltip />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default LineChartComponent;